import { onMounted, onBeforeUnmount } from '@vue/composition-api'

export default function ({ cb, delay = 30 * 1000 }) {
  let interval = null

  const createInterval = () => {
    interval = setInterval(() => {
      if (cb) cb()
    }, delay)
  }

  const destroyInterval = () => {
    clearInterval(interval)
  }

  onMounted(() => createInterval())

  onBeforeUnmount(() => destroyInterval())

  return {
    createInterval,
    destroyInterval,
  }
}
